import { render } from "./SanadDetailByHash.vue?vue&type=template&id=d5d51b86"
import script from "./SanadDetailByHash.vue?vue&type=script&lang=js"
export * from "./SanadDetailByHash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__